import React from "react";

import { type DataTypeProvider } from "@devexpress/dx-react-grid";

import { type FormattedBreakdownTableRow } from "./table";

export const MixCellFormatter = ({
  value,
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const row = _row as FormattedBreakdownTableRow;

  return (
    <div className="flex flex-col justify-center h-full font-mono w-full text-sm">
      <div className="text-cosmic flex justify-end truncate">
        <span>{row.mix}</span>
      </div>
    </div>
  );
};
